import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id E788F50B-B654-4AEC-ACD7-6E9F5AE8B789
 * name view-grid
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/view-grid.svg
 * tags
 * - View 
 */
export const ViewGridIcon = createSvgIcon(<><path d="M3,11H11V3H3M3,21H11V13H3M13,21H21V13H13M13,3V11H21V3" /></>, 'ViewGridIcon');
export default ViewGridIcon